import React, { useState, useEffect } from "react";
import { LinearProgress } from "@mui/material";
import PropTypes from "prop-types";

const PollAnswer = (props) => {
    const {
        answer,
        pollWinner,
        showResults,
        isPollVoted,
        poll,
        vote,
        showVotesCount,
        votedAnswerIds,
    } = props;
    const [percent, setPercent] = useState(0);
    const [isSelected, setIsSelected] = useState(false);
    const [isVoted, setIsVoted] = useState(false);

    const calculatePercent = () => {
        const totalResponses = poll.question.responses;
        if (answer.responses) {
            setPercent(((answer.responses / totalResponses) * 100).toFixed(0));
        }
    };

    const numberToLetter = (number) => {
        return (number + 10).toString(36).toUpperCase();
    };

    const isVotedAnswer = (answerId) => {
        return votedAnswerIds.includes(answerId);
    };

    useEffect(() => {
        setIsVoted(isVotedAnswer(answer.id));
    }, [votedAnswerIds]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            calculatePercent();
        }, 500);
        return () => clearTimeout(timeout);
    }, [poll, pollWinner]);

    return (
        <>
            {!isPollVoted && (
                <div
                    onClick={() => {
                        setIsSelected(true);
                        vote(answer.id);
                    }}
                    className={
                        "grid-x padding-vertical-1  grid-padding-x margin-bottom-20 full width cell choices bordered align-middle " +
                        (showResults ? "align-start" : "") +
                        (isSelected ? " selected" : " pending")
                    }
                    key={answer.id}
                >
                    <div className="cell choice-letter small-1">
                        {numberToLetter(answer.display)}
                    </div>
                    <div
                        className={
                            "cell choice small-" + (showResults ? 9 : 10)
                        }
                    >
                        {answer.answer}
                    </div>
                </div>
            )}
            {isPollVoted && (
                <div
                    className={
                        "grid-x padding-vertical-1 full width cell choices align-middle " +
                        (showResults ? "align-start" : "")
                    }
                    key={answer.id}
                >
                    {isVoted && (
                        <div className="cell choice-letter small-1 voted-choice">
                            <span>
                                <i className="fa fa-check"></i>
                            </span>
                        </div>
                    )}
                    {!isVoted && (
                        <div className="cell choice-letter small-1">
                            <span>{numberToLetter(answer.display)}</span>
                        </div>
                    )}
                    <div
                        className={
                            "cell voted-answer small-" + (showResults ? 9 : 10)
                        }
                    >
                        {answer.answer}
                    </div>
                    {showResults && (
                        <>
                            {showVotesCount && (
                                <div className="cell choice-votes small-2 text-right">
                                    {answer.responses} Votes
                                </div>
                            )}
                            <LinearProgress
                                variant="determinate"
                                value={+percent}
                                thickness={5}
                                className="cell small-12"
                                classes={{
                                    root:
                                        "poll-card-progress-container " +
                                        (answer.responses === pollWinner
                                            ? "poll-winner"
                                            : ""),
                                    bar: "poll-card-progress-bar",
                                    barColorPrimary:
                                        "poll-card-progress-bar-primary",
                                }}
                            />
                            <div className="cell choice-percentage small-12">
                                {percent}%
                            </div>
                        </>
                    )}
                </div>
            )}
        </>
    );
};

PollAnswer.propTypes = {
    answer: PropTypes.object.isRequired,
    pollWinner: PropTypes.number,
    showResults: PropTypes.bool,
    isPollVoted: PropTypes.bool,
    poll: PropTypes.object.isRequired,
    vote: PropTypes.func.isRequired,
    votedAnswerId: PropTypes.string,
};
PollAnswer.defaultProps = {
    showResults: false,
    isPollVoted: false,
};
export default PollAnswer;
